/**
 * `.go-top` floating button — vizibil pe scroll, smooth scroll la top pe click.
 * Port 1:1 din legacy common.js lines 2603-2616.
 */

import { $ } from '../core/selector.js';

export function initGoToTop(): void {
    const goTop = $('.go-top') as Element | null;

    window.addEventListener('scroll', function () {
        if (this.scrollY) {
            goTop?.classList.add('is-visible');
        } else {
            goTop?.classList.remove('is-visible');
        }
    });

    goTop?.on('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}
